import React from 'react';
import { useParams } from 'react-router-dom';
import AddEmployee from './AddEmployee';

/**
 * EditEmployee Component
 * 
 * This is a wrapper component that uses the unified AddEmployee component
 * in edit mode. The AddEmployee component handles both adding and editing
 * employees based on the presence of an employeeId in the URL params.
 */
const EditEmployee = () => {
  const { employeeId } = useParams();

  // The AddEmployee component will detect the employeeId from useParams
  // and automatically switch to edit mode
  return <AddEmployee />;
};

export default EditEmployee;
